const localisation = {
    consistencyCheckTable: {
        columns: {
            productId: {
                headerName: "Product ID",
                description: "",
            },
            sku: {
                headerName: "SKU",
                description: "",
            },
            stockLedgerQuantity: {
                headerName: "Stock Ledger Quantity",
                description: "",
            },
            warehouseQuantity: {
                headerName: "Warehouse Quantity",
                description: "",
            },
            difference: {
                headerName: "Difference",
                description: "",
            },
            investigated: {
                headerName: "Investigated",
                description: "",
            },
        },
    },
};

export default localisation;